import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { PartnerApi } from './MitgliedschaftPartnerApi';
import { KindApi } from './MitgliedschaftKindApi';
import { MitgliedschaftGutscheinKooperationApi } from './MitgliedschaftMitgliedschaftGutscheinKooperationApi';
import { SimulationTypeApi } from './TypesSimulationTypeApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.Mitgliedschaft.MitgliedschaftAnlageErweiterung
 * Model zur Erweiterung einer Mitgliedschaft (Partner/Kinder)
 * Endpoints: /api/mitgliedschaft/erweitern
 */
export class MitgliedschaftAnlageErweiterungApi extends BaseApiModel {
	constructor(initialProperties?: Partial<MitgliedschaftAnlageErweiterungApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected hatPartner: boolean;
	/**
	 * Description: Hat einen Partner
	 * APIL Type: boolean
	 */
	get HatPartner(): boolean {
		return this.hatPartner;
	}

	/**
	 * Description: Hat einen Partner
	 * APIL Type: boolean
	 */
	set HatPartner(value: boolean) {
		this.hatPartner = value;
	}

	protected partner: PartnerApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Mitgliedschaft.Partner
	 */
	get Partner(): PartnerApi {
		return this.partner;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Mitgliedschaft.Partner
	 */
	set Partner(value: PartnerApi) {
		this.partner = value;
	}

	protected hatKinder: boolean;
	/**
	 * Description: Hat Kinder
	 * APIL Type: boolean
	 */
	get HatKinder(): boolean {
		return this.hatKinder;
	}

	/**
	 * Description: Hat Kinder
	 * APIL Type: boolean
	 */
	set HatKinder(value: boolean) {
		this.hatKinder = value;
	}

	protected plusUpgrade: boolean;
	/**
	 * Description: Upgrade auf Plustarif PLU
	 * APIL Type: boolean
	 */
	get PlusUpgrade(): boolean {
		return this.plusUpgrade;
	}

	/**
	 * Description: Upgrade auf Plustarif PLU
	 * APIL Type: boolean
	 */
	set PlusUpgrade(value: boolean) {
		this.plusUpgrade = value;
	}

	protected premiumUpgrade: boolean;
	/**
	 * Description: Upgrade auf Premiumtarif PRE
	 * APIL Type: boolean
	 */
	get PremiumUpgrade(): boolean {
		return this.premiumUpgrade;
	}

	/**
	 * Description: Upgrade auf Premiumtarif PRE
	 * APIL Type: boolean
	 */
	set PremiumUpgrade(value: boolean) {
		this.premiumUpgrade = value;
	}

	protected kinder: KindApi[];
	/**
	 * Description: Liste der Kinder
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Mitgliedschaft.Kind>
	 */
	get Kinder(): KindApi[] {
		return this.kinder;
	}

	/**
	 * Description: Liste der Kinder
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Mitgliedschaft.Kind>
	 */
	set Kinder(value: KindApi[]) {
		this.kinder = value;
	}

	protected agenturnummer: number;
	/**
	 * Description: Nummer der Agentur
	 * APIL Type: int32
	 */
	get Agenturnummer(): number {
		return this.agenturnummer;
	}

	/**
	 * Description: Nummer der Agentur
	 * APIL Type: int32
	 */
	set Agenturnummer(value: number) {
		this.agenturnummer = value;
	}

	protected werbeschluessel: number;
	/**
	 * Description: Werbeschlüssel
	 * APIL Type: int32
	 */
	get Werbeschluessel(): number {
		return this.werbeschluessel;
	}

	/**
	 * Description: Werbeschlüssel
	 * APIL Type: int32
	 */
	set Werbeschluessel(value: number) {
		this.werbeschluessel = value;
	}

	protected werbernummer: number;
	/**
	 * Description: Mitgliedsnumemr des Werbenden
	 * APIL Type: int32
	 */
	get Werbernummer(): number {
		return this.werbernummer;
	}

	/**
	 * Description: Mitgliedsnumemr des Werbenden
	 * APIL Type: int32
	 */
	set Werbernummer(value: number) {
		this.werbernummer = value;
	}

	protected werbegeschenk: number;
	/**
	 * Description: Nummer Prämie für den Werbenden
	 * APIL Type: int32
	 */
	get Werbegeschenk(): number {
		return this.werbegeschenk;
	}

	/**
	 * Description: Nummer Prämie für den Werbenden
	 * APIL Type: int32
	 */
	set Werbegeschenk(value: number) {
		this.werbegeschenk = value;
	}

	protected gutscheindaten: MitgliedschaftGutscheinKooperationApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Mitgliedschaft.MitgliedschaftGutscheinKooperation
	 */
	get Gutscheindaten(): MitgliedschaftGutscheinKooperationApi {
		return this.gutscheindaten;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Mitgliedschaft.MitgliedschaftGutscheinKooperation
	 */
	set Gutscheindaten(value: MitgliedschaftGutscheinKooperationApi) {
		this.gutscheindaten = value;
	}

	protected widerrufAkzeptiert: boolean;
	/**
	 * Description: Wurde die Widerrufsbelehrung akzeptiert
	 * APIL Type: boolean
	 */
	get WiderrufAkzeptiert(): boolean {
		return this.widerrufAkzeptiert;
	}

	/**
	 * Description: Wurde die Widerrufsbelehrung akzeptiert
	 * APIL Type: boolean
	 */
	set WiderrufAkzeptiert(value: boolean) {
		this.widerrufAkzeptiert = value;
	}

	protected bestimmungenAkzepiert: boolean;
	/**
	 * Description: Wurden die Bestimmungen zur Mitgliedschaft und die Leistungsordnung akzepiert
	 * APIL Type: boolean
	 */
	get BestimmungenAkzepiert(): boolean {
		return this.bestimmungenAkzepiert;
	}

	/**
	 * Description: Wurden die Bestimmungen zur Mitgliedschaft und die Leistungsordnung akzepiert
	 * APIL Type: boolean
	 */
	set BestimmungenAkzepiert(value: boolean) {
		this.bestimmungenAkzepiert = value;
	}

	protected simulationType: SimulationTypeApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.SimulationType
	 */
	get SimulationType(): SimulationTypeApi {
		return this.simulationType;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.SimulationType
	 */
	set SimulationType(value: SimulationTypeApi) {
		this.simulationType = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MitgliedschaftAnlageErweiterungApi {
		return AppUtils.Helper.createFromMap(dataObject, MitgliedschaftAnlageErweiterungApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'partner':
					return PartnerApi.createFromObject(value);
				case 'kinder':
					const resultkinder = new Array<KindApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultkinder.push(KindApi.createFromObject(v));
						});
					}
					return resultkinder;
				case 'gutscheindaten':
					return MitgliedschaftGutscheinKooperationApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.HatPartner = this.hatPartner;
		if (this.partner) {
			result.Partner = this.partner.toRequestObject();
		}
		result.HatKinder = this.hatKinder;
		result.PlusUpgrade = this.plusUpgrade;
		result.PremiumUpgrade = this.premiumUpgrade;
		const kinderArrayReqObject: object[] = [];
		this.kinder.forEach((element) => {
			kinderArrayReqObject.push(element.toRequestObject());
		});
		result.Kinder = kinderArrayReqObject;
		result.Agenturnummer = this.agenturnummer;
		result.Werbeschluessel = this.werbeschluessel;
		result.Werbernummer = this.werbernummer;
		result.Werbegeschenk = this.werbegeschenk;
		if (this.gutscheindaten) {
			result.Gutscheindaten = this.gutscheindaten.toRequestObject();
		}
		result.WiderrufAkzeptiert = this.widerrufAkzeptiert;
		result.BestimmungenAkzepiert = this.bestimmungenAkzepiert;
		result.SimulationType = this.simulationType;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}